<template>
  <div class="app-container" :id="nodeId+'-p'" :class="['app-container', currentType === 'homework' ? 'game-size-2' : 'game-size-1' , state ? 'show-game' : 'hide-game']">
    <div style="display: flex;justify-content: center">
      <iframe allow="clipboard-read; clipboard-write" :style="{width:canvasWidth+ 'px',height: canvasHeight+'px'}" :width="canvasWidth"
              :height="canvasHeight" ref="iframe" style="width: 1400px;height: 720px;border: none" :src="srcUrl" />
    </div>
  </div>
</template>

<script>
import store from '@/store'
import {mapGetters} from "vuex";
export default {
  name: 'gameRender',
  computed:{
    ...mapGetters(['isCollapse']),
  },
  props: {
    problemInfo: {
      type: Object,
      default: null
    },
    userHomeworkResult: {
      type: Object,
      default: null
    },
    size: {
      type: Number,
      default: 0.2
    },
    top: {
      type: String,
      default: "54%"
    },
    lang: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      nodeId: 'unity-canvas',
      myUnityInstance: null,
      canvasWidth: 100,
      canvasHeight: 100,
      preCanvasWidth: 0,
      preCanvasHeight: 0,
      gameSceneLoading: true,
      gameStatus: 0,
      code: null,
      state: false, // true显示,false隐藏
      loadingInstance: null,
      type: 1,
      currentType: 'homework',
      mainDocument: null,
      srcUrl: this.$isElectron() ? 'game://./game/index.html' : '/game/index.html'
    }
  },
  watch: {
    problemInfo(nVal, oVal) {
      // console.log(window.myUnityInstance)

      if (this.$store.getters.gameLoadingFinish) {
        console.log(nVal,'nval')
        if(nVal && nVal.homeworkItemInfo.problem_type === 9) {
          this.gameLoadGameEditorScene();
        }else if(nVal && (nVal.homeworkItemInfo.problem_type === 2 || nVal.homeworkItemInfo.problem_type === 6)) {
          this.gameLoadingLevelScene()
        }

        if(!nVal||!oVal||nVal.problem.id!=oVal.problem.id){
          this.loading("正在加载游戏", 1);
        }
      }
    },
    userHomeworkResult(val) {
      if (val && this.$store.getters.gameLoadingFinish) {
        console.log('*************set')
        this.code = val.result.code
        this.gameInitCode(this.code)
      }
    },
    isCollapse(nVal, oVal){
      setTimeout(_ => {
        let width = document.body.clientWidth - document.querySelector('.left-menu').clientWidth;
        let height = document.body.clientHeight - document.querySelector('.navbar').clientHeight;
        this.resizeCanvasContainer(width,height, 'battle');
      }, 300)
    }
  },
  created() {
    const that = this
    // 监听来自主进程的响应
    if (this.$isElectron()) {
      const { ipcRenderer } = require('electron');
      ipcRenderer.on('clipboard-content', (event, clipboardText) => {
        that.iframeWin.postMessage({
          cmd: 'NotifyClipboardContent',
          params: { msg: clipboardText }
        }, '*')
      });
      ipcRenderer.on('game-quit', (event, clipboardText) => {
        that.iframeWin.postMessage({
          cmd: 'GameQuit'
        }, '*')
      });
    }
    this.mainDocument = document
  },
  mounted() {
    this.loading("正在加载资源文件", 0);
    this.canvasHeight = document.body.clientHeight - (document.body.clientHeight * this.size)
    this.canvasWidth = this.canvasHeight * 16 / 9
    window.addEventListener('message', this.notifyMessage) // 添加监听
    window.addEventListener('resize', this.setIframeSize); // 监听窗口大小改变
    this.iframeWin = this.$refs.iframe.contentWindow // 获取iframe信息
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setIframeSize);
    window.removeEventListener('message', this.notifyMessage);
  },
  methods: {
    loading(text, type){
      this.type = type;
      if(this.loadingInstance) this.loadingInstance.close();
      this.loadingInstance = this.$loading({
        body: true,
        text: text,
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    },
    setState(type) {
      if(!this.$store.getters.gameLoadingFinish) return false
      console.log("--------------", type);
      this.state = type
      if(!type){
        this.iframeWin.postMessage({
          cmd: 'NotifyGameShowOrHide',
          params: { msg: 0 }
        }, '*')
      }else{
        this.iframeWin.postMessage({
          cmd: 'NotifyGameShowOrHide',
          params: { msg: 1 }
        }, '*')
      }
      this.resizeCanvasContainer(100,100, 'code')
    },
    loadCodeBattleMainScene(width,height){
      this.gameSceneLoading = true
      this.resizeCanvasContainer(width,height, 'battle')
      this.iframeWin.postMessage({
        cmd: 'LoadCodeBattleMainScene',
      }, '*')
    },
    loadPBLEditorMainScene(width,height) {
      this.gameSceneLoading = true
      this.resizeCanvasContainer(width,height, 'pblEditor')
      this.iframeWin.postMessage({
        cmd: 'LoadGameEditorMainSceneName',
      }, '*')
    },
    resizeCanvasContainer(width,height, type) {
      this.currentType = type
      this.setIframeSize()
      // if(!width){
      //   width =  this.canvasWidth
      //   height =  this.canvasHeight
      // }else{
      //   if(type !== 'pblEditor' && type !== 'fullScreen'){
      //     let formatHeight = width * 9 / 16
      //     let formatWidth = height * 16 / 9
      //     if(formatHeight > height){
      //       width = formatWidth
      //     }else if(formatWidth > width){
      //       height = formatHeight
      //     }
      //   }
      // }
      // let elep = document.querySelector('#'+this.nodeId+'-p')
      // let leftWidth
      // switch (type) {
      //   case 'battle':
      //     leftWidth = document.querySelector('.left-menu').clientWidth;
      //     // elep.style.left =  (bodyWidth - leftWidth - width) / 2 + leftWidth + 'px'
      //     elep.style.left =  '9.6rem'
      //     elep.style.top =  '2.4rem'
      //     elep.style.transform =  'none'
      //     break
      //   case 'pblEditor':
      //     console.log('pblEditor')
      //     leftWidth = document.querySelector('.left-menu').clientWidth;
      //     // elep.style.left =  (bodyWidth - leftWidth - width) / 2 + leftWidth + 'px'
      //     elep.style.left =  '9.6rem'
      //     elep.style.top =  '2.4rem'
      //     elep.style.transform =  'none'
      //     break
      //   case 'fullScreen':
      //     elep.style.left =  0
      //     elep.style.top =  0
      //     elep.style.width = '100vw'
      //     elep.style.height = '100vh'
      //     break
      //   default:
      //     // height = document.body.clientHeight
      //     width = document.body.clientWidth
      //     height = document.body.clientHeight - (document.body.clientHeight * this.size)
      //     // width = this.canvasHeight * 16 / 9
      //     elep.style.transform =  'translate(-50%, -50%)'
      //     elep.style.left =  '50%'
      //     elep.style.top = this.top
      // }
      //
      // this.canvasWidth = width
      // this.canvasHeight = height
    },
    // 接收通知
    notifyMessage(event) {
      const data = event.data
      if (data.cmd === 1) this.gameLoadingCompleted(data.params)
      if (data.cmd === 2) this.gameOverNotifyCode(data.params)
      else if (data.cmd === 3) this.gameOverNotifyGamePass(data.params)
      else if (data.cmd === 4) this.gameLoadingLevelSceneCompleted(data.params)
      else if (data.cmd === 5) this.gameRunning(data.params)
      else if (data.cmd === 6) this.gameOpenProblem(data.params)
      else if (data.cmd === 7) this.gameFullScreen(data.params)
      else if (data.cmd === 8) this.gameSavePBLEditorCode(data.params)
      else if (data.cmd === 9) this.gameLoadPBLEditorCode(data.params)
      else if (data.cmd === 10) this.gameInitUserHomeworkResult()
      else if (data.cmd === 11) this.gameNotifyClipboardContent()
      else if (data.cmd === 12) this.gameLoadingClangLld()
    },
    initGame() {
      window.createUnityInstance(document.querySelector('#' + this.nodeId), {
        dataUrl: 'static/game/Build/286eefcf2bd16d3f635d960b5c1c2ee0.data.unityweb',
        frameworkUrl: 'static/game/Build/37b5098ad296209ac87746112dd2040f.js.unityweb',
        codeUrl: 'static/game/Build/b7efa2b16853f9fe1ad6d4a72ac585ad.wasm.unityweb',
        streamingAssetsUrl: 'static/game/StreamingAssets',
        companyName: 'DefaultCompany',
        productName: 'Client',
        productVersion: '0.1'
      }).then((unityInstance) => {
        if(this.problemInfo){
          this.gameLoadingLevelScene()
        }
        if(this.loadingInstance&&this.type == 0) this.loadingInstance.close();
      })
    },
    gameInitCode(code) {
      console.log(this.userHomeworkResult)
      console.log('***********判断是否需要设置代码：', this.userHomeworkResult ? '是' : '否')
      console.log("***********设置代码：\n", this.code)
      console.log("***********设置代码：\n", code)
      if(this.state){
        this.iframeWin.postMessage({
          cmd: 'SetPlayerCodeContent',
          params: { msg: code }
        }, '*')
      }
      // this.iframeWin.postMessage({
      //   cmd: 'SetPlayerCodeContent',
      //   params: { code: code }
      // }, '*')
    },
    // 游戏结束，通知代码
    gameOverNotifyCode(code) {
      console.log('***********游戏结束代码内容通知：', code)
    },
    gameLoadingLevelScene() {
      console.log('***********游戏场景切换', this.problemInfo)
      this.gameSceneLoading = true
      const lang = this.problemInfo.homeworkItemInfo.problem_type === 2 ? 1 : 6
      this.iframeWin.postMessage({
        cmd: 'LoadScene',
        params: { msg: {level: this.problemInfo.problem.level, lang: lang} }
      }, '*')
    },
    gameLoadingLevelSceneCompleted() {
      if (this.userHomeworkResult) {
        this.code = this.userHomeworkResult.result.code
        console.log('***********设置代码：', this.code)
        this.gameInitCode(this.code)
      }
      this.gameSceneLoading = false
      this.gameStatus = 0
      console.log('***********游戏场景加载完毕')
      if(this.loadingInstance&&this.type == 1) this.loadingInstance.close();
    },
    async gameLoadingClangLld() {
      if(typeof window.moduleCache === 'undefined') {
        window.moduleCache = {}
        if(this.$isElectron()) {
          window.moduleCache["clang"] = await this.compileStreaming("game://./game/clang/clang");
          window.moduleCache["lld"] = await this.compileStreaming("game://./game/clang/lld");
        }else{
          window.moduleCache["clang"] = await this.compileStreaming("https://program-school.oss-cn-beijing.aliyuncs.com/game/static-v5/clang/clang");
          window.moduleCache["lld"] = await this.compileStreaming("https://program-school.oss-cn-beijing.aliyuncs.com/game/static-v5/clang/lld");
        }
      }
      this.iframeWin.postMessage({
        cmd: 'importLib'
      }, '*')
    },
    async compileStreaming(filename) {
      const response = await fetch(filename);
      return WebAssembly.compile(await response.arrayBuffer());
    },
    gameRunning() {
      // 游戏运行状态分为3中 0：未运行 1：运行中 2：运行结束
      // 正常流程 0->1->2->提交代码
      // 异常情况(极限情况) 0->1->场景切换中->2->提交代码
      // 解决：每次场景加载完成时，游戏运行状态初始化为0 ，点击运行时游戏运行状态为1 ， 运行结束时游戏运行状态为2
      // 场景切换时 游戏运行状态为3 只有当游戏状态为1时，通知游戏结束的接口才提交请求
      console.log("11111");
      this.gameStatus = 1
      this.$emit('runningGame', this.gameStatus)
    },
    gameOverNotifyGamePass(msg) {
      console.log(9999, msg);
      if(msg){
        const data = {
          codeContent: msg.code,
          language: 1,
          result: msg.result
        }
        if (this.gameStatus === 1) {
          console.log('************游戏提交数据', data)
          this.$emit('commitResult', data, function (res) {
          })
          console.log('***********游戏结束通关通知：', msg)
        } else {
          console.log('***********游戏运行状态异常，不提交游戏结果')
        }
      }
      this.gameStatus = 2;
      this.$emit('runningGame', this.gameStatus)
    },
    gameSavePBLEditorCode(data) {
      if(this.$route.name === 'pblEditor'){
        this.$emit('commitResult', data, function (res) {
        })
      }else{
        this.$emit('commitResult', {codeContent: data.code, language: 0, result: 4}, function (res) {
        })
      }

    },
    gameLoadPBLEditorCode(data) {
      this.$emit('runningGame', data)
    },
    gameInitUserHomeworkResult() {
      this.$emit('initUserHomeworkResult')
    },
    gameOpenProblem(msg) {
      let data = JSON.parse(msg)
      let problemId = null
      if(data.problemId){
        problemId = data.problemId[0]
      }
      this.$emit('openUnlockProblem',problemId)
    },
    gameNoticeReloadChipInfo() {
      this.iframeWin.postMessage({
        cmd: 'NotifyCodeBattleChipCastQuestionUnlock',
        params: { msg: "" }
      }, '*')
    },
    gameNoticeCaptureAllKeyboardInput(msg) {
      this.iframeWin.postMessage({
        cmd: 'NotifyGameCaptureAllKeyboardInput',
        params: { msg: msg }
      }, '*')
    },
    gameLoadGameEditorScene() {
      console.log(this.problemInfo)
      this.iframeWin.postMessage({
        cmd: 'LoadGameEditorScene',
        params: { msg: this.problemInfo.problem.project_id + ',1' }
      }, '*')
    },
    // 游戏界面加载完成
    gameLoadingCompleted(msg) {
      const isDevelopment = process.env.NODE_ENV !== 'production'
      if(true){
        const msg = process.env.VUE_APP_BASE_URL.replace('/api','') + '/code_api/code_game_api'
        this.iframeWin.postMessage({
          cmd: 'NotifySchoolPostUrl',
          params: { msg: msg }
        }, '*')
      }
      this.iframeWin.postMessage({
        cmd: 'NotifyGameShowOrHide',
        params: { msg: 0 }
      }, '*')
      const token = store.getters.token
      if(token){
        this.iframeWin.postMessage({
          cmd: 'NotifyCookie',
          params: { msg: token }
        }, '*')
      }
      if(this.problemInfo){
        if(this.problemInfo.homeworkItemInfo.problem_type === 2 || this.problemInfo.homeworkItemInfo.problem_type === 6){
          this.gameLoadingLevelScene()
        }else if(this.problemInfo.homeworkItemInfo.problem_type === 9) {
          this.gameLoadGameEditorScene()
        }
      }
      if(this.loadingInstance&&this.type == 0) {
        this.loadingInstance.close();
        this.$store.dispatch('game/change_game_loading_state', true)
      }
    },
    gameQuit(callback) {
      const that = this
      if (this.$store.getters.gameLoadingFinish) {
        let gl = document.getElementById("unity-canvas").getContext("webgl2")
        gl.clear(gl.COLOR_BUFFER_BIT);
        window.myUnityInstance.Quit()
        // gl.clearBufferiv(gl.COLOR, 0, [0.0, 0.0, 0.0, 0.0]);
        // gl.clear(gl.DEPTH_BUFFER_BIT );
        // gl.clear(gl.STENCIL_BUFFER_BIT  );
        // console.log(gl.getParameter(gl.COLOR_CLEAR_VALUE))
        // console.log(gl.getParameter(gl.DEPTH_CLEAR_VALUE))
        // console.log(gl.getParameter(gl.STENCIL_CLEAR_VALUE))
        // console.log(gl.getParameter(gl.ARRAY_BUFFER_BINDING))
        // console.log(gl.getParameter(gl.ELEMENT_ARRAY_BUFFER_BINDING))
        // console.log(gl.getParameter(gl.TEXTURE_BINDING_3D))
        // console.log(gl.getParameter(gl.TEXTURE_BINDING_2D_ARRAY))
        // console.log(gl.getParameter(gl.COMPRESSED_TEXTURE_FORMATS))
        // console.log(gl.getBufferParameter(gl.ARRAY_BUFFER, gl.BUFFER_SIZE))
        // console.log(gl.getContextAttributes()) ■■■
        // gl.deleteBuffer(gl.getParameter(gl.ARRAY_BUFFER_BINDING));
        // gl.deleteBuffer(gl.getParameter(gl.ELEMENT_ARRAY_BUFFER_BINDING));
        // gl.deleteTexture(gl.getParameter(gl.TEXTURE_BINDING_3D));
        // gl.clear(gl.COLOR_BUFFER_BIT);
        // gl.deleteProgram(gl.getParameter(gl.CURRENT_PROGRAM))
      }
    },
    gameFullScreen(fullScreen) {
      if(this.$route.name !== 'pblEditor') return false
      if(fullScreen) {
        this.resizeCanvasContainer(window.innerWidth,window.innerHeight, 'fullScreen')
      }else{
        this.currentType = 'pblEditor'
        this.setIframeSize()
      }
    },
    gameNotifyClipboardContent() {
      if (this.$isElectron()) {
        const { ipcRenderer } = require('electron');
        ipcRenderer.send('get-clipboard-content')
      }
    },
    setIframeSize() { // 设置iframe大小
      let elep = document.querySelector('#unity-canvas-p');
      const navBarHeight = document.querySelector('.navbar')?.offsetHeight
      const homeworkNavBar = document.querySelector('.ass-head')?.offsetHeight
      const leftMenu = document.querySelector('.left-menu')?.offsetWidth
      const bodyHeight = document.body.clientHeight
      const bodyWidth = document.body.clientWidth
      elep.style.transform =  'none'
      let ch, cw;
      if (this.currentType === 'battle') {
        let pRatio = (bodyWidth - leftMenu) / (bodyHeight - navBarHeight);
        if (pRatio > 16 / 9) {
          ch = bodyHeight - navBarHeight;
          cw = ch * 16 / 9;
        } else {
          cw = bodyWidth - leftMenu;
          ch = cw / 16 * 9;
        }
        elep.style.width = cw + 'px'
        elep.style.height = ch + 'px'
        elep.style.left =  (bodyWidth - cw - leftMenu)/2 + leftMenu + 'px'
        elep.style.top =  (bodyHeight - ch - navBarHeight)/2 + navBarHeight + 'px'
      } else if(this.currentType === 'pblEditor') {
        ch = bodyHeight - navBarHeight
        cw = bodyWidth - leftMenu
        elep.style.width = cw + 'px'
        elep.style.height = ch + 'px'
        elep.style.left =  leftMenu + 'px'
        elep.style.top =  navBarHeight + 'px'
      }else if(this.currentType === 'fullScreen'){
        ch = document.body.clientHeight
        cw = document.body.clientWidth
        elep.style.left =  0
        elep.style.top =  0
        elep.style.width = '100vw'
        elep.style.height = '100vh'
      }else{
        // // height = document.body.clientHeight
        // width = document.body.clientWidth
        // height = document.body.clientHeight - (document.body.clientHeight * this.size)
        // width = this.canvasHeight * 16 / 9
        // elep.style.transform =  'translate(-50%, -50%)'
        ch = bodyHeight - homeworkNavBar
        cw = bodyWidth
        elep.style.top =  homeworkNavBar + 'px'
        elep.style.left =  0
        elep.style.width = '100vw'
        elep.style.height = 'calc(100vh - '+ homeworkNavBar +'px)'
        if(this.$route.name === 'competition') {
          elep.style.height = 'calc(100vh - '+ homeworkNavBar +'px - 4.58rem)'
          ch = elep.offsetHeight
        }
      }
      this.canvasHeight = ch;
      this.canvasWidth = cw;

    },
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 0.5rem;
  bottom: 0.5rem;
  width: calc(100vw - 9.6rem);
  height: calc(100vh - 2.4rem);

  &.game-size-2 {
    width: 100vw;
    height: 100vh;
  }

  &.game-size-3 {
    width: calc(100vw);
    height: calc(100vh);
    top: 0;
    left: 0;
  }

  &.show-game {
    z-index: 999;
  }

  &.hide-game {
    z-index: -1;
  }

  iframe {
    width: 1400px;
    height: 720px;
    border: none;
  }
}
</style>
